import { Either } from "../../core/types/Either";

export abstract class IdCardRepository {
  abstract getIdCard(
    appId?: number,
    productType?: string,
    isLegacyApp?: boolean
  ): Promise<Either<Error, Blob>>;
}
